import { useEffect } from 'react';

const HOST_TO_PANEL = [
  { host: '.fondo', panel: '.banner' },
  { host: '.skill', panel: '.skill-bx' },
  { host: '.experience', panel: '.experience-bx' },
  { host: '.project', panel: '.project-bx' },
  { host: '.apps', panel: '.apps-bx' },
  { host: '.contact', panel: '.contact-bx' },
];

const DIRECTIONS = ['bottom', 'top', 'left', 'right', 'diag', 'flipY', 'flipX', 'pop'];

function useComixReveal() {
    useEffect(() => {
        const pairs = HOST_TO_PANEL
            .map(({ host, panel }) => ({
                host: document.querySelector(host),
                panel: document.querySelector(panel),
            }))
            .filter(({ host, panel }) => host && panel);
        if (!pairs.length) return;

        const reduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

        if (reduced) {
            pairs.forEach(({ panel }) => panel.classList.add('comix-visible'));
            return;
        }

        pairs.forEach(({ panel }) => {
            const direction = DIRECTIONS[Math.floor(Math.random() * DIRECTIONS.length)];
            panel.dataset.comix = direction;
        });

        const observer = new IntersectionObserver(
            (entries) => {
                entries.forEach((entry) => {
                    if (!entry.isIntersecting) return;
                    const pair = pairs.find((p) => p.host === entry.target);
                    if (pair) pair.panel.classList.add('comix-visible');
                    observer.unobserve(entry.target);
                });
            },
            // Dispara ANTES de que la seccion entre al viewport (lead de 40%
            // del alto del viewport) para que no haya zona vacia al scrollear.
            { threshold: 0, rootMargin: '0px 0px 40% 0px' }
        );

        pairs.forEach(({ host }) => observer.observe(host));
        return () => observer.disconnect();
    }, []);
}

export default useComixReveal;
